export const PEP_TYPES = {
  NON_PEP: 'non_pep',
  RELATED: 'related',
  EXTRA_OFFICIAL: 'extraoficial',
  HOLDER: 'holder',
  NOT_AVAILIABLE: null,
}

export const PEP_TYPES_MESSAGE = {
  non_pep: 'Não é PEP',
  related: 'PEP relacionado',
  extraoficial: 'PEP extraoficial',
  holder: 'PEP titular',
  null: 'Não informado',
  undefined: 'Não informado',
}
